import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ReactNotification from 'react-notifications-component';

import Layout from 'components/Layout/Layout';

import 'react-notifications-component/dist/theme.css';

class Main extends Component {

  render() {
    return (
      <div className='app-container'>
        <ReactNotification />
        <Layout history={this.props.history} />
      </div>
    );
  }
}

export default translate()(Main);
